  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
      const openButton = event.target.closest('[data-back-in-stock-open]');
      const closeButton = event.target.closest('[data-back-in-stock-close]');

      if (openButton) {
        event.preventDefault();
        event.stopPropagation();

        const modalId = openButton.getAttribute('data-back-in-stock-open');
        const modal = document.getElementById(modalId);

        if (!modal) {
          return;
        }
        if (modal.parentElement !== document.body) {
  document.body.appendChild(modal);
}

        modal.removeAttribute('hidden');
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        const emailInput = modal.querySelector('input[type="email"]');
        if (emailInput) {
          setTimeout(function() {
            emailInput.focus();
          }, 50);
        }
      }
      if (closeButton) {
        event.preventDefault();

        const modal = closeButton.closest('.back-in-stock-modal');

        if (modal) {
          modal.setAttribute('hidden', '');
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('.back-in-stock-modal.is-open').forEach(function(modal) {
        modal.setAttribute('hidden', '');
        modal.classList.remove('is-open');
      });

      document.body.style.overflow = '';
    });
  });